/// <reference path="../../typings/tsd.d.ts" />
module warsApp.services {
    

    export class ManageScheduledResourcesService extends services.DataService<Wars.Domain.Model.ScheduledResourceConfiguration> {
        
        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http:angular.IHttpService) {
            super(injectedBreeze, $q);
        }

        public createNewScheduledResourceConfiguration(codeGroup: Wars.Domain.Model.Codes.CodeGroup): Wars.Domain.Model.ScheduledResourceConfiguration {
            var scheduledResourceConfig = this.createNewEntity<Wars.Domain.Model.ScheduledResourceConfiguration>("ScheduledResourceConfiguration", { myParentCodeGroup: codeGroup });
            scheduledResourceConfig.uniqueIdentifier = UtilityService.generateGuidComb();
            return scheduledResourceConfig;
        }
        
        public getAllScheduledResourcesForProcessConfiguration(id: string): ng.IPromise<Wars.Domain.Model.ScheduledResourceConfiguration[]> {
            const query = this.breezeModule.EntityQuery
                .from("ScheduledResourceConfigurations")
                .where("processConfiguration_id", "==", id);
            return this.executeQuery(query);
        }

        public getAllScheduledResourcesForProcessConfigurationAndSystem(id: string): ng.IPromise<Wars.Domain.Model.ScheduledResourceConfiguration[]> {
            const pred = this.breezeModule.Predicate
                .create('processConfiguration_id', '==', id)
                .or('processConfiguration_id', '==', null);

            const query = this.breezeModule.EntityQuery
                .from("ScheduledResourceConfigurations")
                .where(pred);

            return this.executeQuery(query);
        }

        public checkScheduledResource(
            processId: string,
            formDataId: string,
            schemaPropertyId: string,
            scheduleEntry: Wars.Domain.Model.Execution.ScheduleEntry): angular.IPromise<string>
        {
            var d = this.$q.defer();
            var payload = {
                processId: processId,
                FormDataId: formDataId,
                schemaPropertyId: schemaPropertyId,
                scheduleEntry: scheduleEntry
            };

            this.$http.post('./api/ScheduledResource/CheckSchedule', payload).then(r => { d.resolve(r.data); });
            return d.promise;
        }

    }
}

warsApp.registerService('ManageScheduledResourcesService', ['breeze', '$q','$http']);